<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch00_fm06_con"></a><a id="page_vii"></a><strong>CONTENTS</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">T<span class="small">HE</span> M<span class="small">IDDLEMAN</span></a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">A W<span class="small">IFE’S</span> S<span class="small">TORY</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">L<span class="small">OOSE</span> E<span class="small">NDS</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">O<span class="small">RBITING</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">F<span class="small">IGHTING FOR THE</span> R<span class="small">EBOUND</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">T<span class="small">HE</span> T<span class="small">ENANT</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">F<span class="small">ATHERING</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">J<span class="small">ASMINE</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">D<span class="small">ANNY’S</span> G<span class="small">IRLS</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">B<span class="small">URIED</span> L<span class="small">IVES</span></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">T<span class="small">HE</span> M<span class="small">ANAGEMENT OF</span> G<span class="small">RIEF</span></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_con.vue?65fa9052